import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2020 Airbnb clone! No rights reserved - Prakash Anand<a href="https://github.com/GHATAK123/airbnb-clone"><b>(Ghatak123)</b></a></p>
            <p>Privacy · Terms · Sitemap · Company Details</p>
        </div>
    )
}

export default Footer